// createApi import unused in this file; API slice is injected from apiSlice
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { createApi } from '@reduxjs/toolkit/query/react';
import { apiSlice } from './apiSlice';
import { ApiResponse, Warehouse } from '../../types';

export interface WarehouseWithStats extends Warehouse {
  _count: {
    cargoOnWarehouse: number;
  };
  totalWeight?: number;
  totalVolume?: number;
}

export interface WarehouseDetails extends WarehouseWithStats {
  cargoOnWarehouse: Array<{
    id: number;
    name: string;
    quantity: number;
    totalWeightKg: number;
    status: string;
    createdAt: string;
    application: {
      id: number;
      internalNumber: string;
      client: {
        id: number;
        name: string;
      };
    };
  }>;
}

export interface CreateWarehouseRequest {
  name: string;
  city: string;
  address?: string;
  contactPerson?: string;
  phone?: string;
}

export interface UpdateWarehouseRequest extends CreateWarehouseRequest {
  id: number;
}

export const warehousesApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    // Получить все склады
    getAllWarehouses: builder.query<WarehouseWithStats[], void>({
      query: () => 'references/warehouses',
      transformResponse: (response: ApiResponse<WarehouseWithStats[]>) => response.data || [],
      providesTags: ['Warehouse']
    }),

    // Получить склад по ID
    getWarehouseById: builder.query<WarehouseDetails, number>({
      query: (id) => `references/warehouses/${id}`,
      transformResponse: (response: ApiResponse<WarehouseDetails>) => response.data!,
      providesTags: (result, error, id) => [{ type: 'Warehouse', id }]
    }),

    // Создать склад
    createWarehouse: builder.mutation<Warehouse, CreateWarehouseRequest>({
      query: (data) => ({
        url: 'references/warehouses',
        method: 'POST',
        body: data,
      }),
      transformResponse: (response: ApiResponse<Warehouse>) => response.data!,
      invalidatesTags: ['Warehouse']
    }),

    // Обновить склад
    updateWarehouse: builder.mutation<Warehouse, UpdateWarehouseRequest>({
      query: ({ id, ...data }) => ({
        url: `references/warehouses/${id}`,
        method: 'PUT',
        body: data,
      }),
      transformResponse: (response: ApiResponse<Warehouse>) => response.data!,
      invalidatesTags: (result, error, { id }) => [{ type: 'Warehouse', id }, 'Warehouse']
    }),

    // Удалить склад
    deleteWarehouse: builder.mutation<void, number>({
      query: (id) => ({
        url: `references/warehouses/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['Warehouse']
    }),
  }),
});

export const {
  useGetAllWarehousesQuery,
  useGetWarehouseByIdQuery,
  useCreateWarehouseMutation,
  useUpdateWarehouseMutation,
  useDeleteWarehouseMutation,
} = warehousesApi; 